class SuccessStoriesOverview
    constructor: (el) ->
        @.$el = el
        @.$itemsEl = @.$el.querySelector '.success-stories-overview__items'
        @.$loadMoreButton = @.$el.querySelector '.success-stories-overview__load-more-button'

        @.amount = @.$el.dataset?.amount ? 4
        @.api = @.$el.dataset?.api ? false
        @.apiMethod = @.$el.dataset?.apiMethod ? 'GET'
        @.loaded = @.$el.querySelectorAll('.success-stories-overview__item').length
        @.total = @.$el.dataset?.total ? 0

        @.$el.classList.add 'success-stories-overview--bound'
        @.InitEvents()
        if @.loaded == 0 && @.api && @.apiMethod
            @.GetData()
        else if @.loaded == 0
            @.RemoveSuccessStoriesOverview()
        @.CheckLoadMoreButtonState()
        return

    AppendResults: (newResults) ->
        newResults = newResults ? []
        if newResults.length > 0
            self = @
            newResults.forEach (successStory) ->
                successStory.attrs = {
                    class: ['success-stories-overview__item']
                }
                successStoryEl = window.CreateSuccessStory successStory
                self.$itemsEl.appendChild successStoryEl
                self.loaded++
                return
        window.dispatchEvent new CustomEvent 'bind-components', {bubbles: false}
        @.CheckLoadMoreButtonState()
        return
    
    CheckLoadMoreButtonState: ->
        if @.$loadMoreButton && @.api && @.apiMethod
            if @.total > 0 && @.loaded < @.total
                @.$loadMoreButton.disabled = false
            else
                @.$loadMoreButton.disabled = true
        return

    GetData: ->
        if @.api && @.apiMethod && (@.total == -1 || @.loaded < @.total)
            newResults = []
            if @.apiMethod == 'GET' || @.apiMethod == 'POST'
                self = @
                try
                    if @.apiMethod == 'POST'
                        body = {
                            amount: @.amount
                            offset: @.loaded
                        }
                    request = window.appUtils.XMLHttpRequest @.apiMethod, @.api
                        , ->
                            if request.responseText && request.responseText != ""
                                try
                                    answer = JSON.parse request.responseText
                                    newResults = answer
                                catch error
                                    console.log "Fehler beim Versuch die Datenquelle für Erfolgsgeschichten zu verarbeiten"
                                    return
                            else
                                console.log "Die Anfrage an die Datenquelle für Erfolgsgeschichten lieferte ein leeres Ergebnis"
                            self.AppendResults newResults
                        , ->
                            console.log "Bei der Anfrage an die Datenquelle für Erfolgsgeschichten ist leider ein Fehler aufgetreten"
                            self.AppendResults newResults
                            return
                        , if self.apiMethod == 'POST' then JSON.stringify(body) else {}
                catch error
                    console.log "Fehler beim Versuch die Datenquelle für Erfolgsgeschichten zu ermitteln"
                    self.AppendResults newResults
            else
                
                try
                    if window[@.api]
                        newResults = window[@.api]
                    else
                        console.log "Fehler beim Versuch die Datenquelle für Erfolgsgeschichten zu ermitteln"
                    @.AppendResults newResults
                catch error
                    console.log "Fehler beim Versuch die Datenquelle für Erfolgsgeschichten zu verarbeiten"
                    @.AppendResults newResults
        return

    InitEvents: ->
        self = @
        if @.$loadMoreButton && @.api
            @.$loadMoreButton.addEventListener 'click', (e) ->
                if !@.disabled
                    self.GetData()
                return
        else
            if @.$loadMoreButton
                @.$loadMoreButton.remove()
        return
    
    RemoveSuccessStoriesOverview: ->
        @.$el.remove()
        delete @
        return

BindSuccessStoriesOverviews = ->
    document.querySelectorAll '.success-stories-overview:not(.success-stories-overview--bound)'
        .forEach (el) ->
            new SuccessStoriesOverview el
            return
    return

window.addEventListener 'bind-components', BindSuccessStoriesOverviews